import { types as ActionTypes, asyncEvents as AsyncEvents } from './RequestConversation.actions';
import {
    asyncReducer,
    errorReducer,
    genericReducer,
    loadingReducer,
} from '/b2b/common/helpers/ReduxHelpers';

import { types as AuthActionTypes } from '/b2b/authentication/state/Auth.actions';
import AuthenticatedPaths from '/b2b/routing/AuthenticatedRoutes/AuthenticatedRoutes.paths';
import { types as NavActionTypes } from '/b2b/common/state/nav/Nav.actions';
import { combineReducers } from 'redux';
import reduceReducers from 'reduce-reducers';

export const OPTIMISTIC_MESSAGE_ID = 'optimistic';

export const MESSAGE_STATUS = {
    PENDING: 'pending',
    SENT: 'sent',
    FAILED: 'failed',
};

export const initialState = {
    error: null,
    loading: false,
    messages: [],
    sending: false,
};

// Only fetchConversation types drive the global loading state
const fetchAsyncTypes = Object.keys(AsyncEvents)
    .filter(key => key.startsWith('fetchConversation'))
    .map(key => ActionTypes[key]);

const messagesReducer = (state = initialState.messages, action = {}) => {
    const { type, payload, meta } = action;

    switch (type) {
        case ActionTypes.sendMessageBegin: {
            // withMeta shifts params into meta; content and messageAttachment are in meta
            const { content, messageAttachment } = meta || {};
            const optimisticMessage = {
                messageId: OPTIMISTIC_MESSAGE_ID,
                content,
                isEndUserMsg: false,
                sent: Date.now(),
                status: MESSAGE_STATUS.PENDING,
                attachments: messageAttachment ? [{ ...messageAttachment }] : [],
            };
            return [...state, optimisticMessage];
        }
        case ActionTypes.sendMessageSuccess: {
            // withMeta: response is shifted into payload.params
            const { params: messages = [] } = payload || {};
            return messages || state;
        }
        case ActionTypes.sendMessageFailure: {
            return state.map(msg =>
                msg.messageId === OPTIMISTIC_MESSAGE_ID
                    ? { ...msg, status: MESSAGE_STATUS.FAILED }
                    : msg
            );
        }
        default:
            return state;
    }
};

export default reduceReducers(
    initialState,
    combineReducers({
        error: errorReducer(initialState.error, fetchAsyncTypes),
        loading: loadingReducer(initialState.loading, fetchAsyncTypes),
        messages: reduceReducers(
            initialState.messages,
            asyncReducer(initialState.messages, fetchAsyncTypes, {
                onSuccess: (state, { params: messages = [] }) => messages || state,
            }),
            messagesReducer
        ),
        sending: (state = initialState.sending, { type } = {}) => {
            switch (type) {
                case ActionTypes.sendMessageBegin:
                    return true;
                case ActionTypes.sendMessageSuccess:
                case ActionTypes.sendMessageFailure:
                    return false;
                default:
                    return state;
            }
        },
    }),
    genericReducer(initialState, {
        [AuthActionTypes.logout]: () => initialState,
        [NavActionTypes.routeChanged]: (state, { location }) => {
            if (location.pathname.startsWith(AuthenticatedPaths.DSAR_REQUESTS)) {
                return state;
            }
            return initialState;
        },
    })
);
